import { render } from "./color_list.vue?vue&type=template&id=5e450513&scoped=true"
import script from "./color_list.vue?vue&type=script&lang=js"
export * from "./color_list.vue?vue&type=script&lang=js"

import "./color_list.vue?vue&type=style&index=0&id=5e450513&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e450513"]])

export default __exports__